import { configureStore } from "@reduxjs/toolkit";
import projectDatareducer from "./reducers/projectSlice";
import etlDatareducer from "./reducers/etlSlice";
export const store = configureStore({
  reducer: { project: projectDatareducer, etl: etlDatareducer },
});
